// material-ui
import { Box, Stack, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import PersonalTasks from 'components/PersonalTasks';
import Customization from './Customization';
import MobileSection from './MobileSection';
import Notification from './Notification';
import Profile from './Profile';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

// types
import { MenuOrientation } from 'types/config';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  // eslint-disable-next-line react-hooks/exhaustive-deps

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {downLG && <Box sx={{ width: '100%' }} />}

      <Stack direction="row" spacing={1} sx={{ alignItems: 'center', ml: 'auto', mr: 1 }}>
        <PersonalTasks eventTaskPath={null} prominent />
        <Notification />
        <Customization />
        {!downLG && <Profile />}
        {downLG && <MobileSection />}
      </Stack>
    </>
  );
};

export default HeaderContent;
